export const common = {
  is: {
	home: "Heim",
	company: "Fyrirtækið",
	services: "Þjónusta",
	solutions: "Lausnir",
	projects: "Verkefni",
	contact: "Hafa samband",
	getQuote: "Fá tilboð",
	readMore: "Lesa meira",
	orderNow: "Panta núna",
	learnMore: "Kynnast betur",
	back: "Til baka",
	share: "Deila",
	copied: "Afritað",
	search: "Leita",
	all: "Allt",
	featured: "Vinsælast",
	price: "Verð",
	features: "Eiginleikar",
	included: "Innifalið",
	loading: "Hleður...",
	quickLinks: "Flýtitenglar",
	seeAllProjects: "Skoða öll verkefni"
  },
  en: {
	home: "Home",
	company: "Company",
	services: "Services",
	solutions: "Solutions",
	projects: "Projects",
	contact: "Contact",
	getQuote: "Get Quote",
	readMore: "Read More",
	orderNow: "Order Now",
	learnMore: "Learn More",
	back: "Back",
	share: "Share",
	copied: "Copied",
	search: "Search",
	all: "All",
	featured: "Featured",
	price: "Price",
	features: "Features",
	included: "Included",
	loading: "Loading...",
	quickLinks: "Quick Links",
	seeAllProjects: "See all projects"
  },
  es: {
	home: "Inicio",
	company: "Empresa",
	services: "Servicios",
	solutions: "Soluciones",
	projects: "Proyectos",
	contact: "Contacto",
	getQuote: "Obtener presupuesto",
	readMore: "Leer más",
	orderNow: "Ordenar ahora",
	learnMore: "Saber más",
	back: "Volver",
	share: "Compartir",
	copied: "Copiado",
	search: "Buscar",
	all: "Todo",
	featured: "Destacado",
	price: "Precio",
	features: "Características",
	included: "Incluido",
	loading: "Cargando...",
	quickLinks: "Enlaces rápidos",
	seeAllProjects: "Ver todos los proyectos"
  },
  da: {
	home: "Hjem",
	company: "Virksomhed",
	services: "Tjenester",
	solutions: "Løsninger",
	projects: "Projekter",
	contact: "Kontakt",
	getQuote: "Få tilbud",
	readMore: "Læs mere",
	orderNow: "Bestil nu",
	learnMore: "Lær mere",
	back: "Tilbage",
	share: "Del",
	copied: "Kopieret",
	search: "Søg",
	all: "Alle",
	featured: "Fremhævet",
	price: "Pris",
	features: "Funktioner",
	included: "Inkluderet",
	loading: "Indlæser...",
	quickLinks: "Hurtige links",
	seeAllProjects: "Se alle projekter"
  }
};